import { render } from "./TeamMembers.vue?vue&type=template&id=6e63f892"
import script from "./TeamMembers.vue?vue&type=script&lang=js"
export * from "./TeamMembers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/settings/TeamMembers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e63f892"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e63f892', __exports__)) {
    api.reload('6e63f892', __exports__)
  }
  
  module.hot.accept("./TeamMembers.vue?vue&type=template&id=6e63f892", () => {
    api.rerender('6e63f892', render)
  })

}


export default __exports__